export default __webpack_public_path__ + "static/media/ZachBoemer_Resume.c847afff.pdf";